import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

import ShopsContext from "../../../../context/ShopsContext";

function AddSegmentModal({ show, handleClose, product, onAdded }) {
    const shopsContext = useContext(ShopsContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [startTime, setStartTime] = useState("09:00");
    const [durationInMinutes, setDurationInMinutes] = useState("");
    const [price, setPrice] = useState("");

    const reset = useCallback(() => {
        setLoading(false);
        setError(null);
        setStartTime("09:00");
        setDurationInMinutes("");
        setPrice("");
    }, []);

    const handleSave = useCallback(async () => {
        if(!startTime || !durationInMinutes || !price) {
            setError("Alle velden zijn vereist.");
            return;
        }
        const duration = Number(durationInMinutes);
        if(!Number.isFinite(duration) || !Number.isInteger(duration) || duration <= 0) {
            setError("Duur moet groter zijn dan 0.");
            return;
        }
        const priceNum = Number(price);
        if(!Number.isFinite(priceNum) || priceNum < 0) {
            setError("Prijs mag niet negatief zijn.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post("/addRentalProductSegment", {
                shopId: shopsContext.currentShop.id,
                productId: product.id,
                durationInMinutes: duration,
                startTime: startTime + ":00",
                price: priceNum,
            });
            if(response.data.valid) {
                handleClose();
                onAdded?.();
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
        setLoading(false);
    }, [shopsContext.currentShop.id, product, startTime, durationInMinutes, price, handleClose, onAdded]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ reset }>
            <Modal.Header closeButton>
                <Modal.Title>Segment toevoegen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <div className="form-group">
                    <label htmlFor="segmentStartTime">Starttijd</label>
                    <input
                        type="time"
                        className="form-control"
                        id="segmentStartTime"
                        value={ startTime }
                        onChange={ (event) => setStartTime(event.target.value) }
                        disabled={ loading }
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="segmentDuration">Duur (minuten)</label>
                    <input
                        type="number"
                        className="form-control"
                        id="segmentDuration"
                        value={ durationInMinutes }
                        onChange={ (event) => setDurationInMinutes(event.target.value) }
                        disabled={ loading }
                        min="1"
                        placeholder="120"
                    />
                </div>
                <div className="form-group mb-0">
                    <label htmlFor="segmentPrice">Prijs (Euro &euro;)</label>
                    <input
                        type="number"
                        className="form-control"
                        id="segmentPrice"
                        value={ price }
                        onChange={ (event) => setPrice(event.target.value) }
                        disabled={ loading }
                        min="0"
                        step="0.01"
                        placeholder="0.00"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleren
                </Button>
                <Button variant="primary" onClick={ handleSave } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Toevoegen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
AddSegmentModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    onAdded: PropTypes.func,
}

export default React.memo(AddSegmentModal);
